exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-wrap[data-v-6a0f08be]{margin-bottom:10px}.block-wrap .block-hd[data-v-6a0f08be]{font-size:18px;min-height:55px;line-height:55px;margin-bottom:20px}", ""]);

// exports
